import React, { Component, PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import moment from 'moment'
import { trackPromise } from 'react-promise-tracker'
import cookie from 'react-cookies'

import {
  getMealsList,
  getUserDailyBalance,
} from '../../../Api/dietApi/userInfo'

import MealsScreen from './MealsScreen.tsx'

class MealsScreenContainer extends PureComponent {
  state = {
    // isDemoAccount: cookie.load('userDemoMode'),
    challengeMode: this.props.location.challengeMode
  }

  componentDidMount = async () => {
    await this.getMealTypeFromUrl()
    await this.getChosenFilters()
    await this.getDietMeals()
    await this.setCorrectMealType()
    await this.getDates()
    await this.getUserDiet()
  }

  getDates = () => {
    this.setState({
      todayDate: this.props.match.params.todayDate,
      chosenDate: this.props.match.params.chosenDate,
    })
  }

  getUserDiet = async () => {
    const userBalance = await trackPromise(
      getUserDailyBalance(moment().format('YYYY-MM-DD'))
    )

    if (userBalance) {
      this.setState({
        diet: userBalance.diet,
      })
    }
  }
  setCorrectMealType = () => {
    switch (this.props.location.chosedMealType) {
      case 'sniadanie':
        this.setState({
          chosedMealType: 'Śniadanie',
        })
        break
      case 'IIsniadanie':
        this.setState({
          chosedMealType: 'II śniadanie',
        })
        break
      case 'obiad':
        this.setState({
          chosedMealType: 'Obiad',
        })
        break
      case 'kolacja':
        this.setState({
          chosedMealType: 'Kolacja',
        })
        break
      case 'przekaska':
        this.setState({
          chosedMealType: 'Przekąska',
        })
        break
      default:
        break
    }
  }

  getMealTypeFromUrl = () => {
    let properMealType
    switch (this.props.match.params.mealType) {
      case 'sniadanie':
        properMealType = 'Śniadanie'
        break
      case 'IIsniadanie':
        properMealType = 'II śniadanie'
        break
      case 'obiad':
        properMealType = 'Obiad'
        break
      case 'kolacja':
        properMealType = 'Kolacja'
        break
      case 'przekaska':
        properMealType = 'Przekąska'
        break
    }

    this.setState({
      properMealTypeFromUrl: properMealType,
    })
  }

  getChosenFilters = () => {
    if (cookie.load('mealTypeFilter')) {
      this.setState({
        mealTypeFilters: cookie.load('mealTypeFilter'),
      })
    } else {
      this.setState({
        mealTypeFilters: null,
      })
    }

    if (cookie.load('kcalFilter')) {
      this.setState({
        kcalFilter: cookie.load('kcalFilter'),
      })
    } else {
      this.setState({
        kcalFilter: null,
      })
    }
  }

  getDietMeals = async () => {
    const meals = await trackPromise(getMealsList())

    this.setState({
      meals: meals,
    })
  }

  changeDiet = () => {
    this.props.history.push({
      pathname: '/dieta/wybierz-diete/',
      userChangeDiet: true,
    })
  }

  render() {
    return (
      <MealsScreen
        chosedMealType={this.state.chosedMealType}
        meals={this.state.meals}
        todayDate={this.state.todayDate}
        chosenDate={this.state.chosenDate}
        mealTypefromUrl={this.state.properMealTypeFromUrl}
        mealTypeFilters={this.state.mealTypeFilters}
        kcalFilters={this.state.kcalFilter}
        diet={this.state.diet}
        changeDiet={this.changeDiet}
        // isDemoAccount={this.state.isDemoAccount}
        challengeMode={this.state.challengeMode}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    diet: state.diet,
  }
}

// function mapDispatchToProps(dispatch) {
//   return {
//     dietActions: bindActionCreators(dietActions, dispatch),
//   }
// }

export default compose(
  withRouter,
  connect(mapStateToProps)
)(MealsScreenContainer)
